// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"DemandsModal_tooltip__DZBZI"};